import { withStyles } from '@material-ui/core';
import FsCaption from 'ui-elements/typography/FsCaption';

export const Caption = withStyles(({ palette, spacing }) => ({
  root: {
    color: palette.grey[300],
    marginBottom: spacing(1.5),
    display: 'block',
  },
}))(FsCaption);
